import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AiSkillDto, UpdateAiSkillConfigurationDto } from '@travel-planner/library-travel-planner-api';
import { ApiError } from '../../../../core/models/api-error';

export const AiSkillsActions = createActionGroup({
    source: 'AiSkills',
    events: {
        'Load Ai Skills': emptyProps(),
        'Load Ai Skills Success': props<{ skills: AiSkillDto[] }>(),
        'Load Ai Skills Failure': props<{ error: ApiError }>(),
        'Update Ai Skill Configuration': props<{
            key: string;
            configuration: UpdateAiSkillConfigurationDto;
        }>(),
        'Update Ai Skill Configuration Success': props<{ skill: AiSkillDto }>(),
        'Update Ai Skill Configuration Failure': props<{ key: string; error: ApiError }>(),
        'Reset Ai Skill Configuration': props<{ key: string }>(),
        'Reset Ai Skill Configuration Success': props<{ skill: AiSkillDto }>(),
        'Reset Ai Skill Configuration Failure': props<{ key: string; error: ApiError }>(),
    }
});
